// extracted by css-extract-rspack-plugin
export default {"sidePanel":"ChecksSection-module__sidePanel__cx1Ds"};